import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/useAuth.js";
import { userApi } from "../../api/auctiongate.js";

export default function CurrencyAndContacts() {
  const { user } = useAuth();
  const [course, setCourse] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    userApi.course().then(
      (r) => !cancelled && setCourse(r),
      (e) => !cancelled && setErr(e?.message || "Failed to load rate")
    );
    return () => {
      cancelled = true;
    };
  }, []);

  const employees = Array.isArray(user?.employeeInfo) ? user.employeeInfo : [];

  return (
    <div className="card">
      <div className="card__title">Currency & Contacts</div>
      <div className="grid grid-2">
        <div>
          <div className="small muted">EUR → USD (ECB)</div>
          {err && <div className="login-error small">{err}</div>}
          {!err && !course && <span className="loader" />}
          {course && (
            <div style={{ fontSize: 20, fontWeight: 700, color: "var(--color-text-secondary)" }}>
              {Number(course.rate).toFixed(4)}
              <span className="small muted" style={{ marginLeft: 8 }}>
                {course.cached ? "cached" : "fresh"}
              </span>
            </div>
          )}
        </div>
        <div>
          <div className="small muted">Manager contacts</div>
          {employees.length === 0 ? (
            <div className="small muted">—</div>
          ) : (
            employees.slice(0, 3).map((e, i) => (
              <div key={i} className="small">
                <b>{e.name || e.full_name || "—"}</b>
                {e.position && <span className="muted"> · {e.position}</span>}
                {e.email && (
                  <>
                    {" "}
                    · <a href={`mailto:${e.email}`}>{e.email}</a>
                  </>
                )}
                {e.phone && <span className="muted"> · {e.phone}</span>}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
